import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download_production/6a68abbfa875aa0014626809_1785324458673_c4893c50/buildbridge/src/app/components/LandingPageContent.tsx");
